const ImpressumPage = () => {
  return (
    <div className="w-full max-w-[1280px] mx-auto px-5 md:px-6 pt-[80px] pb-[48px]">
      <h1 className="!text-left text-[var(--primary)]">Impressum</h1>

      <div className="mt-8 font-body text-[16px] [&_a]:underline [&_a]:font-extrabold [&_a]:text-black">
        <p>British American Tobacco (Germany) GmbH</p>
        <p>Alsterufer 4</p>
        <p>20354 Hamburg</p>

        <p className="mt-4">
          Tel.: <a href="tel:0800-0228546" className="hover:opacity-80">0800-0228546</a> (kostenfrei)
        </p>
        <p>Fax.: +49-40-4151-3231</p>
        <p>
          E-Mail: <a href="mailto:service@bat.de" className="hover:opacity-80">service@bat.de</a>
        </p>

        <p className="mt-4">
          Aufsichtsratsvorsitzender British American Tobacco (Germany) GmbH:
        </p>
        <p>Frederico Pinto Monteiro</p>

        <p className="mt-4">
          Geschäftsführer British American Tobacco (Germany) GmbH:
        </p>
        <p>Jorge Araya Remagni (Sprecher)</p>
        <p>Andres Santiago Lorenzo</p>
        <p>Blagoje Jovanovic</p>
        <p>Christopher Voelker</p>

        <p className="mt-4">
          Umsatzsteueridentifikationsnummer British American Tobacco (Germany) GmbH:
        </p>
        <p>DE 8 111 58 553</p>

        <p className="mt-4">
          Sitz und Registergericht:
        </p>
        <p>British American Tobacco (Germany) GmbH: Hamburg, Amtsgericht Hamburg, HRB 1749</p>
      </div>
    </div>
  );
};

export default ImpressumPage;
